import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Drawer, Grid, ListItemIcon, MenuItem } from '@mui/material';
import { ReactComponent as WellGuardianLogo } from 'assets/wg-well-guardian-logo-full.svg';
import { ReactComponent as WellGuardianLogoSmall } from 'assets/wg-well-guardian-logo-half.svg';
import Button from 'components/Button';
import { APPS } from 'constants/appModules';
import useMediaQuery from '@mui/material/useMediaQuery';

import styles from './Sidebar.module.scss';
import { useSidebar } from './useSidebar';
import { useEffect, useState } from 'react';

type Props = {
  isOpen: boolean;
  onSidebarChanged: () => void;
};

const Sidebar = ({ isOpen, onSidebarChanged }: Props) => {
  const maxScreen = useMediaQuery('(max-width:1400px)');
  const [collapsed, setIsCollapsed] = useState<boolean>(false);
  const {
    getStylePerState,
    isOpenDelayed,
    moduleSelectContainer,
    onChangeApp,
    isWellGuardianDisabled,
    getSideBarComponentToRender,
  } = useSidebar({ isOpen, onSidebarChanged, collapsed });

  useEffect(() => {
    if (!isOpenDelayed || (maxScreen && !isOpen)) {
      setIsCollapsed(true);
    } else {
      setIsCollapsed(false);
    }
  }, [isOpen, isOpenDelayed, maxScreen]);

  return (
    <>
      <Drawer
        variant="permanent"
        className={getStylePerState(styles.drawerContainer)}
        anchor="left"
        open={isOpen}
        slotProps={{
          paper: {
            className: getStylePerState(styles.sidebarPaper),
          },
        }}
      >
        <>
          <Grid ref={moduleSelectContainer} container direction="row">
            <div className={styles.moduleSelectContainer} onClick={onChangeApp}>
              <MenuItem disabled={isWellGuardianDisabled} value={APPS.WELL_GUARDIAN}>
                <ListItemIcon>
                  {collapsed ? (
                    <WellGuardianLogoSmall className={styles.wellGuardianLogoSmall} />
                  ) : (
                    <WellGuardianLogo className={styles.wellGuardianLogo} />
                  )}
                </ListItemIcon>
              </MenuItem>
            </div>
          </Grid>
          {getSideBarComponentToRender()}
        </>
      </Drawer>
      <Button className={getStylePerState(styles.toggleDrawerButton)} onClick={onSidebarChanged}>
        <MenuOpenIcon classes={{ root: getStylePerState(styles.buttonArrow) }} />
      </Button>
    </>
  );
};

export default Sidebar;
